var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editor != 0)?_c('div',[_c('ckeditor',{attrs:{"editor":_vm.editor,"value":_vm.editorData,"config":_vm.editorConfig,"disabled":_vm.disabled},model:{value:(_vm.editorData),callback:function ($$v) {_vm.editorData=$$v},expression:"editorData"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }